
import { Component, Vue, Prop } from "vue-property-decorator";
import store from "../../../core/store";
import CampDays from "./campDays.vue";
import { Camp } from "./campPage.vue";
import { Product } from "@shared/core/interfaces/product";
import { Format } from "@shared/core/helpers/formatHelper";

@Component({
  components: {
    CampDays,
  },
})
export default class CampCard extends Vue {
  @Prop() camp!: Camp;
  @Prop() index!: number;
  @Prop({ required: false, default: -1 }) currentIndex!: number;
  private images: unknown[] = [];

  get little() {
    return this.currentIndex === -1 ? false : this.index !== this.currentIndex;
  }

  async mounted() {
    this.setDefaultImages();
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/academy",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  private getImageCamps(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  private getPrice(pr: Product) {
    const price = store.state.settings.PriceWithTaxes
      ? pr.grossPrice
      : pr.netPrice;
    return Format.formatCurrency(price.toString());
  }
}
